import styled from "styled-components";

export const ContainerNps = styled.div`
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px #363435 inset !important;
    box-shadow: 0 0 0 30px #363435 inset;
}
transform-origin: bottom;
animation: animate 0.5s;
overflow: auto;

flex-direction: column;
position: fixed;
z-index: 4;
bottom: 0;
right: 0;
width: 100%;
background-color: #424242;
border-radius: 16px 16px 0px 0px;
display: flex;
justify-content: flex-end;

    @media(min-width: 768px){
        width: 400px;
        right: auto;
    }
    @media(min-width: 1024px){
        width: 420px;
        right: auto;
    }

`

